module.exports = __webpack_public_path__ + "static/prague-2024-3e90c001fae95180dcae2533e8c43d4e.jpg";